import { useState } from 'react';
import { Layout, Typography } from 'antd';
import FileInput from './components/FileInput';
import ResultView from './components/ResultView';
import ThemeToggle from './components/ThemeToggle';
import type { NachaParseResult } from './types/nacha';
import './App.css';

const { Header, Content } = Layout;
const { Title } = Typography;

function App() {
  const [parseResult, setParseResult] = useState<NachaParseResult | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('Processing...');

  const handleLoadingChange = (loading: boolean, text: string) => {
    setIsLoading(loading);
    setLoadingText(text);
  };

  return (
    <Layout className="app-layout">
      <Header className="app-header">
        <div className="header-content">
          <div className="title-section">
            <div className="logo-icon">N</div>
            <div className="title-text">
              <Title level={1} style={{ margin: 0 }}>
                NACHA File Parser
              </Title>
              <span className="subtitle">Professional ACH File Analysis & Validation</span>
            </div>
          </div>
          <div className="header-actions">
            <ThemeToggle />
          </div>
        </div>
      </Header>
      <Content className="app-content">
        <div className="content-wrapper">
          <div className="left-panel">
            <FileInput 
              onParseComplete={setParseResult} 
              onLoadingChange={handleLoadingChange}
            />
          </div>
          <div className="right-panel">
            <ResultView 
              result={parseResult} 
              loading={isLoading}
              loadingText={loadingText}
            />
          </div>
        </div>
      </Content>
    </Layout>
  );
}

export default App;
